/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getTreatmentRadiations } from 'app/entities/treatment-radiation/treatment-radiation.reducer';
import { getEntities as getRadiationBeamParameters } from 'app/entities/radiation-beam-parameter/radiation-beam-parameter.reducer';
import { createEntity, getEntity, reset, updateEntity } from './treatment-radiation-beam-param.reducer';

export const TreatmentRadiationBeamParamUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const treatmentRadiations = useAppSelector(state => state.treatmentRadiation.entities);
  const radiationBeamParameters = useAppSelector(state => state.radiationBeamParameter.entities);
  const treatmentRadiationBeamParamEntity = useAppSelector(state => state.treatmentRadiationBeamParam.entity);
  const loading = useAppSelector(state => state.treatmentRadiationBeamParam.loading);
  const updating = useAppSelector(state => state.treatmentRadiationBeamParam.updating);
  const updateSuccess = useAppSelector(state => state.treatmentRadiationBeamParam.updateSuccess);

  const handleClose = () => {
    navigate(`/treatment-radiation-beam-param${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getTreatmentRadiations({}));
    dispatch(getRadiationBeamParameters({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...treatmentRadiationBeamParamEntity,
      ...values,
      radiationSession: treatmentRadiations.find(it => it.id.toString() === values.radiationSession?.toString()),
      treatmentBeamParam: radiationBeamParameters.find(it => it.id.toString() === values.treatmentBeamParam?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...treatmentRadiationBeamParamEntity,
          radiationSession: treatmentRadiationBeamParamEntity?.radiationSession?.id,
          treatmentBeamParam: treatmentRadiationBeamParamEntity?.treatmentBeamParam?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2
            id="tinyMedicRestApp.treatmentRadiationBeamParam.home.createOrEditLabel"
            data-cy="TreatmentRadiationBeamParamCreateUpdateHeading"
          >
            <Translate contentKey="tinyMedicRestApp.treatmentRadiationBeamParam.home.createOrEditLabel">
              Create or edit a TreatmentRadiationBeamParam
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="treatment-radiation-beam-param-id"
                  label={translate('tinyMedicRestApp.treatmentRadiationBeamParam.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationBeamParam.administeredValue')}
                id="treatment-radiation-beam-param-administeredValue"
                name="administeredValue"
                data-cy="administeredValue"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationBeamParam.active')}
                id="treatment-radiation-beam-param-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationBeamParam.cursor')}
                id="treatment-radiation-beam-param-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationBeamParam.lastUpdated')}
                id="treatment-radiation-beam-param-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationBeamParam.microSec')}
                id="treatment-radiation-beam-param-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.treatmentRadiationBeamParam.timestampEntry')}
                id="treatment-radiation-beam-param-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                id="treatment-radiation-beam-param-radiationSession"
                name="radiationSession"
                data-cy="radiationSession"
                label={translate('tinyMedicRestApp.treatmentRadiationBeamParam.radiationSession')}
                type="select"
              >
                <option value="" key="0" />
                {treatmentRadiations
                  ? treatmentRadiations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="treatment-radiation-beam-param-treatmentBeamParam"
                name="treatmentBeamParam"
                data-cy="treatmentBeamParam"
                label={translate('tinyMedicRestApp.treatmentRadiationBeamParam.treatmentBeamParam')}
                type="select"
              >
                <option value="" key="0" />
                {radiationBeamParameters
                  ? radiationBeamParameters.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button
                tag={Link}
                id="cancel-save"
                data-cy="entityCreateCancelButton"
                to="/treatment-radiation-beam-param"
                replace
                color="info"
              >
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default TreatmentRadiationBeamParamUpdate;
